import React from "react";
import { Box, Typography, Button } from "@mui/material";
import Dismenu from "./Dismenu";

function Disabled() {
  return (
    <>
      <Dismenu />
      <Box
        sx={{
          position: "fixed", // fixes the content on the screen
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh", // full viewport height
          display: "flex",
          flexDirection: "column",
          justifyContent: "center", // vertical center
          alignItems: "center", // horizontal center
          backgroundColor: "#f8f9fa",
          textAlign: "center",
          zIndex: 0,
          marginLeft:12
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2,
            color: "#d6336c",
            fontFamily: "'Roboto', sans-serif",
          }}
        >
           Property Disabled
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: "#495057",
            fontSize: "1.1rem",
            lineHeight: 1.6,
          }}
        >
          Your property has been disabled by the Admin. <br />
          Please contact the Admin for more details.
        </Typography>

       
      </Box>
    </>
  );
}

export default Disabled;
